import { Styles, css, horizontalScrollCss, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    width: 720px;
    max-width: 90vw;
    gap: 16px;
  `,
  details: css`
    display: flex;
    justify-content: space-between;
  `,
  author: css`
    display: flex;
    gap: 4px;
    align-items: center;
  `,
  message: ({ theme }) => css`
    display: block;
    max-height: 80vh;
    overflow: auto;
    padding-right: 8px;
    margin-right: -8px;
    padding-bottom: 8px;
    margin-bottom: -8px;

    ${verticalScrollCss(theme)}
    ${horizontalScrollCss(theme)}
  `,
  messageItem: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[80]};
    line-height: 155%;
    font-size: 13px;
    font-family: arial, sans-serif;
    border: 1px solid ${theme.colors.neutral.variant[10]};
    padding: 8px 16px;

    &:not(:first-of-type) {
      border-top: 0;
    }

    &:first-of-type {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    &:last-of-type {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
